export default "__VITE_ASSET__BYo4QsLF__"